import { ActionTree } from 'vuex';
import { RootState, SingleFilter } from '@/store/types';
import { DocumentState } from './types';

export const actions: ActionTree<DocumentState, RootState> = {
    /** Filters */

    /**
     * Reset a single filter.
     *
     * @param commit
     * @param key
     */
    resetFilter({ commit }, key: string) {
        commit('resetFilter', key);
    },

    /**
     * Set filters.
     *
     * @param commit
     * @param filters
     */
    setFilters({ commit }, filters: SingleFilter[]) {
        filters.map((filter) => commit('setFilter', filter));
    },
};
